
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="workflowTargetInfo.correctRole">
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>This step is currently unavailable.</p>
      </div>
    </div>
  </div>
</div>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row alert-container-block">
    <error [error]="error"></error>
  </div>
  <div class="row">
    <div class="col">
      <p class="text-center">Download ITSM Deployed Assets Report</p>
    </div>
  </div>
  <div class="row">
    <div class="col"> </div>
    <div class="col"><a class="btn btn-primary btn-block" id="downloadITSMReport" [downloadFile]="'/api/DeploymentWorkflow/export-deployed-devices-report'" [params]="{deploymentId: workflowTargetInfo.targetId}"><span class="oi oi-cloud-download"></span> Download ITSM Deployed Assets Report</a></div>
    <div class="col"> </div>
  </div>
</div>